import { createAlbumCarrocel } from '../../../js/album-carrocel.js';

window.createAlbumCarrocel =createAlbumCarrocel;